var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"all"},[_c('headercon'),_vm._v(" "),_c('div',{staticClass:"anniu"},[_c('img',{staticClass:"button",attrs:{"src":_vm.img1,"alt":""},on:{"click":_vm.go}}),_vm._v(" "),_c('img',{staticClass:"button1",attrs:{"src":_vm.img2,"alt":""},on:{"click":_vm.go1}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-3cbb0a0f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/aboutus.vue
// module id = null
// module chunks = 